import { render } from "./Appointment.vue?vue&type=template&id=db2b6a08"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"
script.render = render

export default script